module.exports = __webpack_public_path__ + "img/my.c3d8f526.png";